import {
  Megaphone,
  Share2,
  Send,
  CalendarDays,
  LayoutTemplate,
  PenLine,
  Building2,
} from "lucide-react";
import { NavigationItem } from "../../types";
import { BuilderContext } from "../context";

/**
 * Marketing — outbound tooling: social publishing, email campaigns, the unified
 * marketing calendar, email templates, and signatures. Communications lives
 * under Sales for now.
 */
export function buildMarketingSection(ctx: BuilderContext): NavigationItem | null {
  const { isCRM, isAdmin, isEmployee } = ctx;

  // Available to CRM users, employees, and admins
  if (!(isCRM || isAdmin || isEmployee)) return null;

  const marketingChildren: NavigationItem[] = [
    { id: "social-media-posts", name: "Social Posts", href: "/social-media-posts", icon: Share2 },
    { id: "email-campaigns", name: "Email Campaigns", href: "/campaigns", icon: Send },
    { id: "marketing-calendar", name: "Marketing Calendar", href: "/mktg?tab=calendar", icon: CalendarDays },
    { id: "crm-email-templates", name: "Email Templates", href: "/crm/email-templates", icon: LayoutTemplate },
    { id: "crm-signatures", name: "Email Signatures", href: "/crm/signatures", icon: PenLine },
  ];

  // Brand onboarding (add a brand, connect its social accounts) is ADMIN-ONLY for
  // now — the tab lives on /mktg, which is AdminGuard-wrapped, and every write
  // endpoint re-checks admin auth. Listed here rather than under Admin so it sits
  // with the marketing work it serves. Widening this to more roles is a later
  // scope (per-brand grants).
  if (isAdmin) {
    marketingChildren.push({
      id: "marketing-brands",
      name: "Brands",
      href: "/mktg?tab=brands",
      icon: Building2,
    });
  }

  return {
    id: "marketing",
    name: "Marketing",
    href: "/crm/email-templates",
    icon: Megaphone,
    visible: true,
    order: 2,
    children: marketingChildren,
  };
}
